import { useState, useEffect } from "react";

import BackgroundLandscape from "../app/background.webp";
import BackgroundPortrait from "../app/bg.webp";
import LoadingGif from '../app/loading.gif'

import RectangleButton from "../betbar/rect.png";
import DropdownButton from "../betbar/dropdown.webp";
import Input8 from "../betbar/bg-input-8-rounded.webp";
import Input12 from "../betbar/bg-input-12.webp";
import ButtonCashout from "../betbar/btn_cashout.webp";
import ButtonRandom from "../betbar/btn_PickRandomTitle.webp";
import InfinityIcon from "../betbar/∞.webp";

// import bar_form_landscape from '../betbar/bar-form-landscape.webp'
// import bar_form_portrait from '../betbar/bar-form-portrait.png'

// import PopOutBar from '../history/out/bg.png'
// import PopOutBMP from '../history/out/bmp.png'
// import PopOutClose from '../history/out/close.png'
// import PopOutIconBet from '../history/out/icon_bet.png'
// import PopOutIconCopy from '../history/out/icon_copy.png'
// import PopOutIconLink from '../history/out/icon_link.png'
// import PopOutPlay from '../history/out/play.png'

// import TableBar from '../history/table/bg.webp'
// import TableHead from '../history/table/bg-head.webp'
// import TableX from '../history/table/x.webp'

import VolumeBar from "../setting/bg-range.webp";
import IconFullscreen from "../setting/maximize.webp";
import IconNotFullscreen from "../setting/minimize.webp";
import IconTutorial from "../setting/icon_tutorial.webp";
import IconVolume from "../setting/sound.webp";

import PortalEasy from "../game/close-easy-master.webp";
import PortalMedium from "../game/close-medium-expert.webp";
import PortalHard from "../game/close-hard.webp";
import PortalOpenWinEasy from "../game/open-win-easy-master.webp";
import PortalOpenWinMedium from "../game/open-win-medium-expert.webp";
import PortalOpenWinHard from "../game/open-win-hard.webp";
import PortalOpenLoseEasy from "../game/open-lose-easy-master.webp";
import PortalOpenLoseMedium from "../game/open-lose-medium-expert.webp";
import PortalOpenLoseHard from "../game/open-lose-hard.webp";

import Frame from "../game/frame.png";


import HistoryIcon from "../history/icon-title.webp";
import Up from "../history/eye.webp";
import Expand from "../history/expand.webp";



export const ASSETS_IMAGE_CACHED = "asset-image-cached";

const usePreloadImage = () => {
  const [isReady, setIsReady] = useState(false);
  const [progess, setProgress] = useState(0);

  useEffect(() => {
    setProgress(0);

    const imgs = [
      // App
      BackgroundLandscape,
      BackgroundPortrait,
      LoadingGif,


      // BetBar
      RectangleButton,
      DropdownButton,
      Input8,
      Input12,
      ButtonCashout,
      ButtonRandom,
      InfinityIcon,
      //  bar_form_landscape, bar_form_portrait,

      // Game
      PortalEasy,
      PortalMedium,
      PortalHard,
      PortalOpenWinEasy,
      PortalOpenWinMedium,
      PortalOpenWinHard,
      PortalOpenLoseEasy,
      PortalOpenLoseMedium,
      PortalOpenLoseHard,
      Frame,
      // GameLandscape, GamePortrait, FrameLandscape, FramePortrait, PerentageBar,

      // History
      HistoryIcon, Up, Expand,

      // Setting
      VolumeBar,
      IconFullscreen,
      IconNotFullscreen,
      IconTutorial,
      IconVolume,
    ];
    const onePart = 50 / imgs.length;

    cacheImages(imgs, onePart);
  }, []);

  const cacheImages = async (srcArray: string[], onePart: number) => {
    const promises = await srcArray.map((src) => {
      return new Promise(async function (resolve, reject) {
        const img = new Image();
        const link = document.createElement("link");
        link.rel = "preload";
        link.href = src;
        link.as = "image";
        document.head.appendChild(link);
        img.src = src;

        img.onload = () => {
          setProgress((prev) => (prev += onePart));
          resolve(null);
        };
        img.onerror = () => {
          setProgress((prev) => (prev += onePart));
          reject();
        };

        try {
          if ("caches" in window) {
            await caches.open(ASSETS_IMAGE_CACHED).then(async (cache) => {
              if (src.indexOf("data:image") > -1) {
              } else cache.put(src, (await urlContentToDataUri(src)) as any);
            });
          }
        } catch (error) {}
      });
    });

    await Promise.all(promises);

    setIsReady(true);
  };
  return { isReady, progess };
};

export default usePreloadImage;

function urlContentToDataUri(url: string) {
  return fetch(url);
}
